import { render, staticRenderFns } from "./Fields.vue?vue&type=template&id=5f4b6805"
import script from "./Fields.vue?vue&type=script&lang=js"
export * from "./Fields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports